import { gql } from "config/graphql";
import { ITriviaQuestion } from "config/types";
import { gqlQuery } from "store/apollo";

interface IFetchTriviaResponse {
  data: {
    triviaQuestions: ITriviaQuestion[];
  };
}

export const fetchTriviaQuery = (): Promise<IFetchTriviaResponse> => {
  const query = gql`
    query TriviaQuestions {
      triviaQuestions {
        explanation
        id
        question
        slug
        answers {
          correct
          id
          name
          slug
        }
      }
    }
  `;

  return gqlQuery<IFetchTriviaResponse["data"]>({
    fetchPolicy: "cache-first",
    query,
  });
};
